import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    disabled: {
      opacity: 0.5
    }
  };
});
